// ===== Default Variables =====
let titleFontSize = 3;
let titlePosition = 'top-left';
let titleShadowColor = 'purple';
let titleBorderSize = 0.5;
let titleShadowBlur = 15;
let titleFont = 'Font 1';
// let titleMargin = 0;
// let titleBottomOffset = 30;
let subtitleFontSize = 1.5;
let subtitlePosition = 'below-title';
let subtitleSeparatePosition = 'bottom-right';
let subtitleShadowColor = 'purple';
let subtitleBorderSize = 0.5;
let subtitleShadowBlur = 10;
let subtitleFont = 'Font 1';
let subtitleMargin = 0;

// ===== Shadow Color Mappings =====
const shadowColorMap = {
    'purple': 'rgba(128, 0, 255, 0.8)',
    'blue': 'rgba(0, 102, 255, 0.8)',
    'orange': 'rgba(255, 128, 0, 0.8)',
    'pink': 'rgba(255, 0, 128, 0.8)',
    'green': 'rgba(0, 204, 102, 0.8)',
    'yellow': 'rgba(255, 204, 0, 0.8)',
    'red': 'rgba(255, 0, 0, 0.8)',
    'white': 'rgba(255, 255, 255, 0.8)'
};

// ===== Font Family Mappings =====
const fontFamilyMap = {
    'Font 1': 'Pricedown, "Arial Black", sans-serif',
    'Font 2': 'Respondent, Arial, sans-serif',
    'Font 3': 'SignPainter, cursive, sans-serif',
    'Font 4': 'ChaletComprime, Arial, sans-serif',
    'Font 5': 'ChaletLondon, Arial, sans-serif',
    'Font 6': 'Legal, Arial, sans-serif',
    'Font 7': 'Legal3D, Arial, sans-serif'
};

function syncFormValuesToDOM() {
  document.getElementById('title-font-size').value = titleFontSize;
  document.getElementById('title-font').value = titleFont;
  document.getElementById('title-position').value = titlePosition;
  document.getElementById('title-border-size').value = titleBorderSize;
  document.getElementById('title-shadow-blur').value = titleShadowBlur;

  document.getElementById('subtitle-font-size').value = subtitleFontSize;
  document.getElementById('subtitle-font').value = subtitleFont;
  document.getElementById('subtitle-position').value = subtitlePosition;
  document.getElementById('subtitle-separate-position-select').value = subtitleSeparatePosition;
  document.getElementById('subtitle-border-size').value = subtitleBorderSize;
  document.getElementById('subtitle-shadow-blur').value = subtitleShadowBlur;

//   document.getElementById('title-margin').value = titleMargin;
//   document.getElementById('title-bottom-offset').value = titleBottomOffset;
  document.getElementById('subtitle-margin').value = subtitleMargin;

  // Sync active class for shadow colors (if you’re not relying on it already)
  document.querySelectorAll('#title-shadow-colors .color-option').forEach(el => {
    el.classList.toggle('active', el.dataset.color === titleShadowColor);
  });
  document.querySelectorAll('#subtitle-shadow-colors .color-option').forEach(el => {
    el.classList.toggle('active', el.dataset.color === subtitleShadowColor);
  });
}

function updateSubtitleSeparateOptions() {
  const titleSelect = document.getElementById('title-position');
  const subtitleModeSelect = document.getElementById('subtitle-position');
  const subtitleSeparateSelect = document.getElementById('subtitle-separate-position-select');

  const selectedTitlePos = titleSelect.value;
  const isSeparate = subtitleModeSelect.value === 'separate';

  Array.from(subtitleSeparateSelect.options).forEach(option => {
    if (option.value === selectedTitlePos && isSeparate) {
      option.disabled = true;
      option.style.display = 'none'; // Optional: hide it instead of just disabling
    } else {
      option.disabled = false;
      option.style.display = ''; // Reset display style
    }
  });

  // If current value is disabled, switch to first enabled option
  if (subtitleSeparateSelect.value === selectedTitlePos && isSeparate) {
    const firstValid = Array.from(subtitleSeparateSelect.options).find(opt => !opt.disabled);
    if (firstValid) {
      subtitleSeparateSelect.value = firstValid.value;
      subtitleSeparatePosition = firstValid.value;
      updateTitleStyles(); // re-render positioning
    }
  }
}

// ===== Update Title/SubTitle Styles =====
function updateTitleStyles() {
    const previewCanvas = document.getElementById('preview-canvas');
    const mapTitle = document.getElementById('map-title-preview');
    const mapSubtitle = document.getElementById('map-subtitle-preview');
    const subtitleSeparatePositionDiv = document.getElementById('subtitle-separate-position');
    const marginPx = 0.03 * (previewCanvas ? previewCanvas.offsetWidth : 1200);
    const gap = '0.5em';

    const positions = {
        'top-left':       { top: marginPx, left: marginPx },
        'top-center':     { top: marginPx, left: 'auto', auto: 'auto',tx: 0 },
        'top-right':      { top: marginPx, right: marginPx },
        'center-left':    { top: '50%', left: marginPx, ty: -50 },
        'center':         { top: '50%', left: '50%', tx: -50, ty: -50 },
        'center-right':   { top: '50%', right: marginPx, ty: -50 },
        'bottom-left':    { bottom: marginPx, left: marginPx },
        'bottom-center':  { bottom: marginPx, left: 'auto', auto: 'auto',tx: 0 },
        'bottom-right':   { bottom: marginPx, right: marginPx }
    };

    // const isMobileP = window.innerWidth <= 600;

    // if (isMobileP) {
    //     positions['top-center'].tx = -11;
    //     positions['bottom-center'].tx = -11;
    // }

    if (previewCanvas && mapTitle && mapTitle.parentElement !== previewCanvas) {
        previewCanvas.appendChild(mapTitle);
    }
    if (previewCanvas && mapSubtitle && mapSubtitle.parentElement !== previewCanvas) {
        previewCanvas.appendChild(mapSubtitle);
    }

    const titleInput = document.getElementById('map-title');
    if (titleInput && mapTitle) {
        mapTitle.textContent = titleInput.value;
    }
    const subtitleInput = document.getElementById('map-subtitle');
    if (subtitleInput && mapSubtitle) {
        mapSubtitle.textContent = subtitleInput.value;
    }

    mapTitle.style.fontSize = `${titleFontSize}rem`;
    mapSubtitle.style.fontSize = `${subtitleFontSize}rem`;
    mapTitle.style.fontFamily = fontFamilyMap[titleFont] || 'Pricedown, "Arial Black", sans-serif';
    mapSubtitle.style.fontFamily = fontFamilyMap[subtitleFont] || 'Pricedown, "Arial Black", sans-serif';

    if (titleBorderSize > 0) {
        mapTitle.style.webkitTextStroke = `${titleBorderSize}px #000`;
        mapTitle.style.textStroke = `${titleBorderSize}px #000`;
    } else {
        mapTitle.style.webkitTextStroke = 'none';
        mapTitle.style.textStroke = 'none';
    }

    mapTitle.style.textShadow = `0 0 ${titleShadowBlur}px ${shadowColorMap[titleShadowColor]}, 
                                 0 0 ${titleShadowBlur * 2}px ${shadowColorMap[titleShadowColor].replace('0.8', '0.6')}`;

    if (subtitleBorderSize > 0) {
        mapSubtitle.style.webkitTextStroke = `${subtitleBorderSize}px #000`;
        mapSubtitle.style.textStroke = `${subtitleBorderSize}px #000`;
    } else {
        mapSubtitle.style.webkitTextStroke = 'none';
        mapSubtitle.style.textStroke = 'none';
    }

    mapSubtitle.style.textShadow = `0 0 ${subtitleShadowBlur}px ${shadowColorMap[subtitleShadowColor]}, 
                                    0 0 ${subtitleShadowBlur * 2}px ${shadowColorMap[subtitleShadowColor].replace('0.8', '0.6')}`;

    if (subtitlePosition === 'separate') {
        subtitleSeparatePositionDiv.classList.remove('hidden');
    } else {
        subtitleSeparatePositionDiv.classList.add('hidden');
    }

    mapTitle.className = 'title-text font-bold outline-none border-none focus:ring-0 w-full';
    mapSubtitle.className = 'subtitle-text font-semibold outline-none border-none focus:ring-0 w-full';

    [mapTitle, mapSubtitle].forEach(el => {
        el.style.position = 'absolute';
        el.style.top = '';
        el.style.bottom = '';
        el.style.width = 'auto';
        el.style.left = '';
        el.style.right = '';
        el.style.transform = '';
        el.style.textAlign = '';
        // if (el === mapTitle) {
        //     el.style.marginTop = `${titleMargin}px`;
        // } else {
        //     el.style.marginTop = '';
        // }
        el.style.marginBottom = '';
        el.style.display = 'block';
    });

    function applyPosition(el, key, pushDown = false) {
        const p = positions[key];
        const isTitle = el.id === 'map-title-preview';
        const isSubtitle = el.id === 'map-subtitle-preview';

        const subtitleOffset = 25;
        const titleOffset = -20;

        const isMobile = window.innerWidth <= 600;

        if (isMobile) {
            if (isTitle && typeof p.top === 'number') {
                p.top += 15;
            }
            if (isSubtitle && typeof p.top === 'number') {
                // Only adjust if in separate mode with top positions
                if (subtitlePosition === 'separate' && subtitleSeparatePosition.startsWith('top')) {
                    p.top = Math.max(5, p.top); // keep at least 5px inside
                } else {
                    p.top -= 30;
                }
            }
            if (isTitle && typeof p.bottom === 'number') {
                p.bottom += 15;
            }
            if (isSubtitle && typeof p.bottom === 'number') {
                p.bottom -= 10;
            }
        }
        
        if (isSubtitle && typeof p.bottom === 'number') {
            if (subtitlePosition === 'separate' && subtitleSeparatePosition.startsWith('bottom')) {
                p.bottom += 5;
            }
        }

        if (isTitle && typeof p.bottom === 'number') {
            // If title is separated and using bottom positions, push it down closer to bottom
            if (subtitlePosition === 'separate' && titleKey.startsWith('bottom')) {
                p.bottom = Math.max(5, p.bottom - 20); // lower the title
            }
        }

        ["top", "bottom", "left", "right"].forEach(anchor => {
            if (p[anchor] !== undefined) {
                let value = typeof p[anchor] === "number" ? p[anchor] : parseFloat(p[anchor]);

                // if (anchor === 'bottom' && isTitle) {
                //     value += titleBottomOffset;
                // }

                if (anchor === 'top') {
                    if (isTitle) value += titleOffset;
                    if (isSubtitle && subtitlePosition !== 'separate') value += subtitleOffset;
                }

                if (anchor === 'bottom') {
                    if (isTitle && window.innerWidth > 600) {
                        value += 20;
                    }
                    if (isSubtitle && subtitlePosition !== 'separate') {
                        value += -5;
                    }
                }

                el.style[anchor] = typeof value === "number" ? `${value}px` : p[anchor];
            }
        });

        let transforms = [];
        if (p.tx) transforms.push(`translateX(${p.tx}%)`);
        if (p.ty) transforms.push(`translateY(${p.ty}%)`);
        el.style.transform = transforms.join(" ");
        el.style.textAlign = key.endsWith('center') ? 'center' : key.endsWith('right') ? 'right' : 'left';
    }

    let titleKey = titlePosition;
    let subtitleKey = subtitlePosition === 'separate' ? subtitleSeparatePosition : titlePosition;
    let pushDown = (subtitlePosition === 'separate' && titleKey === subtitleKey);
    applyPosition(mapTitle, titleKey, false);
    applyPosition(mapSubtitle, subtitleKey, pushDown);

    if (subtitlePosition === 'below-title' || subtitlePosition === 'with-title') {
        const titleEl = document.getElementById('map-title-preview');
        const titleHeight = titleEl.offsetHeight;
        const gap = subtitleMargin; // whatever gap slider says

        if (titleKey.startsWith('top')) {
            // Always keep subtitle just below title, even if font grows
            mapSubtitle.style.top = `${titleEl.offsetTop + titleHeight + gap}px`;
            mapSubtitle.style.marginTop = '';
            mapSubtitle.style.marginBottom = '';
        } 
        else if (titleKey.startsWith('bottom')) {
            mapSubtitle.style.marginBottom = `${subtitleMargin}px`;
        } 
        else {
            mapSubtitle.style.marginTop = `${subtitleMargin}px`;
        }
    }

  syncFormValuesToDOM()
}

// ===== Initialization =====
document.addEventListener('DOMContentLoaded', () => {
    const titleBorderSizeSlider = document.getElementById('title-border-size');
    const subtitleBorderSizeSlider = document.getElementById('subtitle-border-size');

    if (titleBorderSizeSlider) titleBorderSizeSlider.value = titleBorderSize;
    if (subtitleBorderSizeSlider) subtitleBorderSizeSlider.value = subtitleBorderSize;

    updateTitleStyles();

    document.getElementById('map-title').addEventListener('input', (e) => {
        document.getElementById('map-title-preview').textContent = e.target.value;
        updateTitleStyles();
    });

    document.getElementById('map-subtitle').addEventListener('input', (e) => {
        document.getElementById('map-subtitle-preview').textContent = e.target.value;
        updateTitleStyles();
    });

    document.getElementById('title-font-size').addEventListener('input', (e) => {
      const value = parseFloat(e.target.value);
      titleFontSize = window.innerWidth <= 600 ? value * 0.5 : value;
      updateTitleStyles();
    });

    document.getElementById('title-font-size-2').addEventListener('input', (e) => {
      if (window.innerWidth <= 600) {
        const value = parseFloat(e.target.value);
        titleFontSize = value;
        updateTitleStyles();
      }
    });

    document.getElementById('title-position').addEventListener('change', (e) => {
        titlePosition = e.target.value;
        updateTitleStyles();
        updateSubtitleSeparateOptions();
    });

    document.getElementById('title-font').addEventListener('change', (e) => {
        titleFont = e.target.value;
        updateTitleStyles();
    });

    document.getElementById('title-border-size').addEventListener('input', (e) => {
        titleBorderSize = parseFloat(e.target.value);
        updateTitleStyles();
    });

    document.getElementById('title-border-size-mobile').addEventListener('input', (e) => {
        titleBorderSize = parseFloat(e.target.value);
        updateTitleStyles();
    });

    document.getElementById('title-shadow-blur').addEventListener('input', (e) => {
        titleShadowBlur = parseFloat(e.target.value);
        updateTitleStyles();
    });

    document.getElementById('title-shadow-blur-mobile').addEventListener('input', (e) => {
        titleShadowBlur = parseFloat(e.target.value);
        updateTitleStyles();
    });

    document.getElementById('subtitle-font-size').addEventListener('input', (e) => {
      const value = parseFloat(e.target.value);
      subtitleFontSize = window.innerWidth <= 600 ? value * 0.5 : value;
      updateTitleStyles();
    });

    document.getElementById('subtitle-font-size-2').addEventListener('input', (e) => {
      if (window.innerWidth <= 600) {
        const value = parseFloat(e.target.value);
        subtitleFontSize = value;
        updateTitleStyles();
      }
    });

    document.getElementById('subtitle-position').addEventListener('change', (e) => {
        subtitlePosition = e.target.value;
        updateTitleStyles();
        updateSubtitleSeparateOptions();
    });

    document.getElementById('subtitle-font').addEventListener('change', (e) => {
        subtitleFont = e.target.value;
        updateTitleStyles();
    });

    document.getElementById('subtitle-separate-position-select').addEventListener('change', (e) => {
        subtitleSeparatePosition = e.target.value;
        updateTitleStyles();
    });

    document.getElementById('subtitle-border-size').addEventListener('input', (e) => {
        subtitleBorderSize = parseFloat(e.target.value);
        updateTitleStyles();
    });

    document.getElementById('subtitle-border-size-mobile').addEventListener('input', (e) => {
        subtitleBorderSize = parseFloat(e.target.value);
        updateTitleStyles();
    });

    document.getElementById('subtitle-shadow-blur').addEventListener('input', (e) => {
        subtitleShadowBlur = parseFloat(e.target.value);
        updateTitleStyles();
    });

    document.getElementById('subtitle-shadow-blur-mobile').addEventListener('input', (e) => {
        subtitleShadowBlur = parseFloat(e.target.value);
        updateTitleStyles();
    });

    document.querySelectorAll('#title-shadow-colors .color-option').forEach(option => {
        option.addEventListener('click', () => {
            document.querySelectorAll('#title-shadow-colors .color-option').forEach(opt => opt.classList.remove('active'));
            option.classList.add('active');
            titleShadowColor = option.dataset.color;
            updateTitleStyles();
        });
    });

    document.querySelectorAll('#subtitle-shadow-colors .color-option').forEach(option => {
        option.addEventListener('click', () => {
            document.querySelectorAll('#subtitle-shadow-colors .color-option').forEach(opt => opt.classList.remove('active'));
            option.classList.add('active');
            subtitleShadowColor = option.dataset.color;
            updateTitleStyles();
        });
    });

    const subtitlePositionSelect = document.getElementById('subtitle-position');
    const subtitleMarginContainer = document.getElementById('subtitle-margin-container');
    const titlePositionSelect = document.getElementById('title-position');

    function updateSubtitleMarginVisibility() {
        const isWithOrBelow = (subtitlePositionSelect.value === 'below-title' || subtitlePositionSelect.value === 'with-title');
        const isBottomTitle = titlePositionSelect.value.startsWith('bottom');

        // Show margin slider only if in with/below mode AND not in bottom positions
        subtitleMarginContainer.style.display = (isWithOrBelow && !isBottomTitle) ? '' : 'none';
    }

    // Run on load
    updateSubtitleMarginVisibility();

    // Listen for changes
    subtitlePositionSelect.addEventListener('change', updateSubtitleMarginVisibility);
    titlePositionSelect.addEventListener('change', updateSubtitleMarginVisibility);

    document.getElementById('subtitle-margin').addEventListener('input', (e) => {
        subtitleMargin = parseInt(e.target.value, 10);
        updateTitleStyles();
    });

    // const titleMarginSlider = document.getElementById('title-margin');
    // titleMarginSlider.value = titleMargin;
    // titleMarginSlider.addEventListener('input', (e) => {
    //     titleMargin = parseInt(e.target.value, 10);
    //     updateTitleStyles();
    // });

    // const titleBottomOffsetSlider = document.getElementById('title-bottom-offset');
    // titleBottomOffsetSlider.value = titleBottomOffset;
    // titleBottomOffsetSlider.addEventListener('input', (e) => {
    //     titleBottomOffset = parseInt(e.target.value, 10);
    //     updateTitleStyles();
    // });


    updateSubtitleSeparateOptions();
});

// ===== Responsive Font Resize =====


const baseTitleFontSize = 3;
const baseSubtitleFontSize = 1.5;

function applyResponsiveFontSizes() {
  const isMobile = window.innerWidth <= 600;
  const titleInput = isMobile
    ? document.getElementById('title-font-size-2')
    : document.getElementById('title-font-size');

  const subtitleInput = isMobile
    ? document.getElementById('subtitle-font-size-2')
    : document.getElementById('subtitle-font-size');

  titleFontSize = parseFloat(titleInput.value) * (isMobile ? 1.15 : 1);
  subtitleFontSize = parseFloat(subtitleInput.value) * (isMobile ? 1.2 : 1);

  updateTitleStyles();
}

applyResponsiveFontSizes();
window.addEventListener('resize', applyResponsiveFontSizes);